import type { CSSProperties } from 'react';

import type { RegionDetail } from '../../../../api/regions';

const clearButtonStyle: CSSProperties = {
  marginTop: 8,
  height: 28,
  padding: '0 11px',
  fontSize: 12,
  borderRadius: 6,
  border: '1px solid var(--nb-border)',
  background: 'transparent',
};

/**
 * A subregion that still holds a director of its own — the state BON-443's
 * migration deliberately left for a human when it conflicted with the root's.
 * Name both directors: deciding which one survives needs them side by side.
 * Clearing is the way out, and the API permits it precisely so this can exist.
 */
export function StrandedDirector({
  detail,
  onClear,
  clearing,
}: {
  detail: RegionDetail;
  onClear: () => void;
  clearing: boolean;
}) {
  return (
    <div style={{ fontSize: 12 }}>
      <div>{detail.directorName}</div>
      <div style={{ color: 'var(--nb-text-muted)', marginTop: 2 }}>
        Set on this subregion, which is no longer supported.{' '}
        {detail.inheritedDirectorName
          ? `${detail.inheritedFromRegionName} has ${detail.inheritedDirectorName}.`
          : `${detail.parentName ?? 'Its parent'} has no director.`}{' '}
        Clear it, then set the director on the top-level region.
      </div>
      <button
        type="button"
        onClick={onClear}
        disabled={clearing}
        style={{ ...clearButtonStyle, cursor: clearing ? 'default' : 'pointer' }}
      >
        {clearing ? 'Clearing…' : 'Clear director'}
      </button>
    </div>
  );
}
